import { render, staticRenderFns } from "./Dialogo.vue?vue&type=template&id=05980850&lang=pug&"
import script from "./Dialogo.vue?vue&type=script&lang=js&"
export * from "./Dialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports